import { MemoryNotificationRepository } from "./memoryNotificationRepository";
import { UserNotificationsQuery } from "../application/UserNotificationsQuery";
import { MarkAsReadNotificationCommand } from "../application/MarkAsReadNotificationCommand";
import { APINotificationRepository } from "./apiNotificationRepository";

export function getNotificationData(): UserNotificationsQuery {
  let noti_1 = {
    user_id:1,
    id:'fy2439rfyhui',
    read:false,
    message:'message bla bla',
    subject:'subject bla bla'
  }
  let noti_2 = {
    user_id:1,
    id:'jdkjfh894y',
    read:false,
    message:'message bli bli',
    subject:'subject bli bli'
  }
  let noti_3 = {
    user_id:1,
    id:'kfj33yg932',
    read:true,
    message:'message blo blo',
    subject:'subject blo blo'
  }
  
  const repository = new MemoryNotificationRepository([noti_1,noti_2,noti_3]);
  return new UserNotificationsQuery(repository);
}

export function getNotificationDataApi(): UserNotificationsQuery {
  const repository = new APINotificationRepository();
  return new UserNotificationsQuery(repository);
}

export function markAsReadNotificationApi(): MarkAsReadNotificationCommand{
  const repository = new APINotificationRepository();
  return new MarkAsReadNotificationCommand(repository);
}
